<template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader />
  </div>
  <div v-else>
    <MainHeader :title="'You did it!'"> </MainHeader>
    <div class="view">
      <div>
        <p class="text-center">You're doing awesome. You're ready to budget!</p>
      </div>
      <button class="teal-outline-button w-100" @click="goToDashboard">
        All Done! Let's see your dashboard.
      </button>
    </div>
    <ProgressBar :currentStep="3" :steps="4" />
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { useMyStore } from '../../store.js';
import { onMounted, ref } from 'vue';

import MainHeader from '../../components/View-Header.vue';
import SkeletonLoader from '../../components/SkeletonLoader.vue';
import ProgressBar from '../../components/ProgressBar.vue';

export default {
  components: {
    MainHeader,
    SkeletonLoader,
    ProgressBar,
  },
  setup() {
    const router = useRouter();
    const store = useMyStore();
    const loading = ref(true);
    const premiumUser = store.user.premiumSubscription;

    onMounted(() => {
      loading.value = false;
    });

    const goToDashboard = () => {
      router.push({ name: 'Dashboard' });
    };

    if (!store) {
      return null;
    }

    return {
      router,
      loading,
      goToDashboard,
      premiumUser,
    };
  },
};
</script>
<style scoped>
.settings-list {
  display: grid;
  grid-template-columns: 10% 90%;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  padding: 1em;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 1em;
}

.light-theme .settings-list {
  background: white;
}

.dark-theme .settings-list {
  background: #212e3e;
  color: white;
}

.bank-name {
  color: #004751;
  text-align: center;
  padding-bottom: 0.5em;
  font-size: 1.1em !important;
  font-weight: bold;
}

.bank-group {
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 2.5em;
}

.light-theme .bank-group {
  background: #f8f8f8;
  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
}

.dark-theme .bank-group {
  background: #212e3e;
  color: white;
}

.user-tip {
  border: 1px solid #e2e2e2;
  text-align: center;
  align-items: center;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 1em;
  row-gap: 0.5em;
  margin-bottom: 1em;
}

.light-theme .user-tip {
  background: white;
}

.dark-theme .user-tip {
  background: #212e3e;
}

.user-tip .icon-container {
  text-align: center;
  justify-content: center;
  display: flex;
}

.account-type-checkboxes {
  display: flex;
  flex-direction: column;
}

.example-text {
  font-weight: 400;
  color: #515a65;
  font-size: 0.8em;
}
</style>
